import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { Grid, Box, Modal } from "@mui/material";
import { Form, Formik } from "formik";

import LogoGaBig from "../../assets/images/ga/logo-ga-big.png";
import SipLongLogo from "../../image/sip_long_logo.png";
import CricoExpandedViewLogo from "../../assets/images/crico/crico_expanded_view_logo.png";

import Field from "../../component/Field";
import Label from "../../component/Label";
import Toaster from "../../component/Toaster";
import ActionButton from "../../component/ActionButton";

import { parentLinkAction } from "../../store/parentLink/parentLinkSlice";
import { useAppDispatch } from "../../store/hooks";
import TypographyLabel from "../../component/Typography";
import { Product } from "../../util/Utils";
import { THEME } from "../../util/LookupConst";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "95%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  height: "90%",
  overflowY: "scroll",
  p: 2,
};

const paymentPaidStyle = {
  textAlign: "center",
  color: "#f00",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "80%",
  margin: "10px",
  borderRadius: "15px",
  bgcolor: "#fff8f0",
};

const ParentLinkInvoicePayment = (props: any) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const invoiceId = queryParams.get("invoiceId");

  const [invoiceInfo, setInvoiceInfo] = useState<any>(null);
  // const [expire, setExpire] = useState<any>(false);

  const [open, setOpen] = useState(true);

  useEffect(() => {
    getStudentParentLinkInvoiceInfo();
  }, []);

  const getStudentParentLinkInvoiceInfo = () => {
    if (invoiceId) {
      dispatch(
        parentLinkAction({ invoiceId, apiAction: "parentLinkInvoiceInfo" })
      )
        .then((result: any) => {
          if (result?.payload?.status === 200) {
            setInvoiceInfo(result?.payload?.data.data);
          } else {
            Toaster.error(undefined, result.payload);
            // setExpire(true);
          }
        })
        .catch((err: any) => {
          // This console for debug the app if any error occurred in DEV
          console.log(err);
        });
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = (values: any, { resetForm }: any) => {};

  const payNow = (values: any) => {
    window.open(invoiceInfo?.paymentLink, "_self"); //to open page
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className="center">
          <img
            src={
              Product.ProductCode() === THEME.GA
                ? LogoGaBig
                : Product.ProductCode() === THEME.SA
                ? SipLongLogo
                : CricoExpandedViewLogo
            }
            style={{ height: "54px" }}
            alt="Logo"
          />
        </div>
        {invoiceInfo?.invoiceStatus === "Cancelled" ? (
          <Box sx={paymentPaidStyle}>
            <TypographyLabel
              variant="h2"
              title="The payment has been Cancelled."
            />
          </Box>
        ) : invoiceInfo?.paymentStatus !== "Paid" ? (
          <Formik
            initialValues={{}}
            enableReinitialize={true}
            onSubmit={(values: any, { setSubmitting, resetForm }: any) =>
              handleSubmit(values, { setSubmitting, resetForm })
            }
          >
            {({ values }) => {
              return (
                <Form>
                  <Grid
                    container
                    rowSpacing={1}
                    columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                    style={{ padding: "10px" }}
                  >
                    <Grid item xs={12} sm={6} md={4} lg={4}>
                      <div className="form-ele-gap">
                        <Label title={t("invoiceNo")} />
                        <Field
                          className="textFiled"
                          name="invoiceNo"
                          disabled
                          value={invoiceInfo?.studentInvoiceNumber}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4}>
                      <div className="form-ele-gap">
                        <Label title={t("studentCode")} />
                        <Field
                          className="textFiled"
                          name="studentCode"
                          disabled
                          value={invoiceInfo?.studentCode}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4}>
                      <div className="form-ele-gap">
                        <Label title={t("studentName")} />
                        <Field
                          className="textFiled"
                          name="studentName"
                          disabled
                          value={invoiceInfo?.studentName}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4}>
                      <div className="form-ele-gap">
                        <Label title={t("invoiceDueDate")} />
                        <Field
                          className="textFiled"
                          name="studentInoiceDueDate"
                          disabled
                          value={invoiceInfo?.studentInoiceDueDate}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4}>
                      <div className="form-ele-gap">
                        <Label title={t("invoiceAmount")} />
                        <Field
                          className="textFiled"
                          name="invoiceAmount"
                          disabled
                          value={invoiceInfo?.studentInvoiceAmount}
                        />
                      </div>
                    </Grid>
                  </Grid>
                  <Box
                    className="border-top padding-up-15 center-end flex-gap margin-15"
                    sx={{
                      flexDirection: "row",
                      pt: 2,
                      justifyContent: "end",
                    }}
                  >
                    <ActionButton
                      onClick={() => payNow(values)}
                      label={"Pay Now"}
                    ></ActionButton>
                  </Box>
                </Form>
              );
            }}
          </Formik>
        ) : (
          <Box sx={paymentPaidStyle}>
            <TypographyLabel
              variant="h2"
              title="The payment has already been made."
            />
          </Box>
        )}
      </Box>
    </Modal>
  );
};

export default ParentLinkInvoicePayment;
